import { parseHoursFromAPI } from './ordensServicoTimeUtils';

interface ProcessedHours {
  horasExecutadas: string;
  horasFaturadas: string;
}

export const processOrderHours = (apiData: any, numero: string): ProcessedHours => {
  // Para horas executadas, usar horasTotais como fallback, depois horasExecutadas
  let horasExecutadas = '00:00';
  if (apiData.horasTotais) {
    horasExecutadas = parseHoursFromAPI(apiData.horasTotais);
  } else if (apiData.horasExecutadas) {
    horasExecutadas = parseHoursFromAPI(apiData.horasExecutadas);
  }
  
  // Para horas faturadas, tratar valores nulos explicitamente
  let horasFaturadas = '00:00';
  
  // Se horasFaturadas é null, undefined ou string vazia, sempre usar 00:00
  if (apiData.horasFaturadas === null || apiData.horasFaturadas === undefined || apiData.horasFaturadas === '') {
    horasFaturadas = '00:00';
  } else {
    // Se tem valor, processar normalmente
    horasFaturadas = parseHoursFromAPI(apiData.horasFaturadas);
  }

  return { horasExecutadas, horasFaturadas };
};
